import React from 'react';
import PropTypes from 'prop-types';
import DialogContent from '@material-ui/core/DialogContent';
import {
  DeleteDialog,
  TitleContainer,
  RedWarningIcon,
  Title,
  Subtitle,
  RedCancelIcon,
  Warning,
  WarningMessage,
  Actions,
  ConfirmButton,
  CancelButton
} from './style';

function WarningItem({ message }) {
  return (
    <Warning>
      <RedCancelIcon />
      <WarningMessage>{message}</WarningMessage>
    </Warning>
  );
}

function DeleteDebriefDialog({ open, name, handleConfirm, handleCancel }) {
  return (
    <DeleteDialog
      disableBackdropClick
      disableEscapeKeyDown
      open={open}
      maxWidth='sm'
    >
      <TitleContainer>
        <RedWarningIcon />
        <Title>Delete {name} Debrief?</Title>
      </TitleContainer>
      <DialogContent>
        <Subtitle>
          Warning: this cannot be undone.
        </Subtitle>
        <WarningItem message="All Meeting Notes and Key Takeaways will be deleted" />
        <WarningItem message="All History and Reflections will be deleted" />
        <WarningItem message="All Action Plans will be deleted" />
      </DialogContent>
      <Actions disableSpacing>
        <ConfirmButton onClick={handleConfirm} variant="contained">
          Yes, Delete Debrief
        </ConfirmButton>
        <CancelButton onClick={handleCancel} variant="outlined" color="inherit">
          Cancel, Keep Debrief
        </CancelButton>
      </Actions>
    </DeleteDialog>
  );
}

DeleteDebriefDialog.propTypes = {
  /** Determines if dialog is open */
  open: PropTypes.bool.isRequired,
  /** Name of debrief */
  name: PropTypes.string.isRequired,
  /** Confirms deletion of debrief and closes dialog */
  handleConfirm: PropTypes.func.isRequired,
  /** Closes dialog */
  handleCancel: PropTypes.func.isRequired,
}

export default DeleteDebriefDialog;



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/Debriefs/components/DeleteDebriefDialog/index.jsx